import {
  GetEstadoProceso,
  PostCalcularAlcancesContactCenter,
  PostPrecalculoContactCenter,
  PostCalcularComisionesContactCenter,
  PostCalcularAlcancesClub,
  PostPrecalculoClub,
  PostCalcularComisionesClub,
  DeleteRevertirAlcancesContactCenter,
  DeleteRevertirPrecalculoContactCenter,
  DeleteRevertirComisionesContactCenter,
  DeleteRevertirAlcancesClub,
  DeleteRevertirPrecalculoClub,
  DeleteRevertirComisionesClub,
  DeleteRevertirComisionesSemestral,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

export interface ProcesoAnualidadStore
  extends GetEstadoProceso,
    PostCalcularAlcancesContactCenter,
    PostPrecalculoContactCenter,
    PostCalcularComisionesContactCenter,
    PostCalcularAlcancesClub,
    PostPrecalculoClub,
    PostCalcularComisionesClub,
    DeleteRevertirAlcancesContactCenter,
    DeleteRevertirPrecalculoContactCenter,
    DeleteRevertirComisionesContactCenter,
    DeleteRevertirAlcancesClub,
    DeleteRevertirPrecalculoClub,
    DeleteRevertirComisionesClub,
    DeleteRevertirComisionesSemestral {}

export const procesoAnualidadStore: (
  state
) => ProcesoAnualidadStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    estadoProceso: comisionAnualidad.estadoProceso,
    gettingEstadoProceso: comisionAnualidad.gettingEstadoProceso,
    gettingEstadoProcesoError: comisionAnualidad.gettingEstadoProcesoError,

    calcularAlcancesCCResult: comisionAnualidad.calcularAlcancesCCResult,
    postingCalcularAlcancesCC: comisionAnualidad.postingCalcularAlcancesCC,
    postingCalcularAlcancesCCError:
      comisionAnualidad.postingCalcularAlcancesCCError,

    precalculoCCResult: comisionAnualidad.precalculoCCResult,
    postingPrecalculoCC: comisionAnualidad.postingPrecalculoCC,
    postingPrecalculoCCError: comisionAnualidad.postingPrecalculoCCError,

    calcularComisionesCCResult: comisionAnualidad.calcularComisionesCCResult,
    postingCalcularComisionesCC: comisionAnualidad.postingCalcularComisionesCC,
    postingCalcularComisionesCCError:
      comisionAnualidad.postingCalcularComisionesCCError,

    calcularAlcancesClubResult: comisionAnualidad.calcularAlcancesClubResult,
    postingCalcularAlcancesClub: comisionAnualidad.postingCalcularAlcancesClub,
    postingCalcularAlcancesClubError:
      comisionAnualidad.postingCalcularAlcancesClubError,

    precalculoClubResult: comisionAnualidad.precalculoClubResult,
    postingPrecalculoClub: comisionAnualidad.postingPrecalculoClub,
    postingPrecalculoClubError: comisionAnualidad.postingPrecalculoClubError,

    calcularComisionesClubResult:
      comisionAnualidad.calcularComisionesClubResult,
    postingCalcularComisionesClub:
      comisionAnualidad.postingCalcularComisionesClub,
    postingCalcularComisionesClubError:
      comisionAnualidad.postingCalcularComisionesClubError,

    revertirAlcancesCCResult: comisionAnualidad.revertirAlcancesCCResult,
    deletingRevertirAlcancesCC: comisionAnualidad.deletingRevertirAlcancesCC,
    deletingRevertirAlcancesCCError:
      comisionAnualidad.deletingRevertirAlcancesCCError,

    revertirPrecalculoCCResult: comisionAnualidad.revertirPrecalculoCCResult,
    deletingRevertirPrecalculoCC:
      comisionAnualidad.deletingRevertirPrecalculoCC,
    deletingRevertirPrecalculoCCError:
      comisionAnualidad.deletingRevertirPrecalculoCCError,

    revertirComisionesCCResult: comisionAnualidad.revertirComisionesCCResult,
    deletingRevertirComisionesCC:
      comisionAnualidad.deletingRevertirComisionesCC,
    deletingRevertirComisionesCCError:
      comisionAnualidad.deletingRevertirComisionesCCError,

    revertirAlcancesClubResult: comisionAnualidad.revertirAlcancesClubResult,
    deletingRevertirAlcancesClub:
      comisionAnualidad.deletingRevertirAlcancesClub,
    deletingRevertirAlcancesClubError:
      comisionAnualidad.deletingRevertirAlcancesClubError,

    revertirPrecalculoClubResult:
      comisionAnualidad.revertirPrecalculoClubResult,
    deletingRevertirPrecalculoClub:
      comisionAnualidad.deletingRevertirPrecalculoClub,
    deletingRevertirPrecalculoClubError:
      comisionAnualidad.deletingRevertirPrecalculoClubError,

    revertirComisionesClubResult:
      comisionAnualidad.revertirComisionesClubResult,
    deletingRevertirComisionesClub:
      comisionAnualidad.deletingRevertirComisionesClub,
    deletingRevertirComisionesClubError:
      comisionAnualidad.deletingRevertirComisionesClubError,

    revertirComisionesSemestralResult:
      comisionAnualidad.revertirComisionesSemestralResult,
    deletingRevertirComisionesSemestral:
      comisionAnualidad.deletingRevertirComisionesSemestral,
    deletingRevertirComisionesSemestralError:
      comisionAnualidad.deletingRevertirComisionesSemestralError
  };
};
